/* eslint-disable no-return-await */
/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react'
import TotalIndustriCompanyPage from 'src/pages/ReportsPages/ReportsBoard/MarketShareReportsPages/TotalIndustriCompanyPage'
import boardReportsService from 'src/services/boardReportsService'
import polygonsService from 'src/services/polygonsService'

const TotalIndustryCompanyContainer = () => {
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [totalIndustry, setTotalIndustry] = useState([])
  const [gTotalIndustry, setGTotalIndustry] = useState([])
  const [gTotalIndustryA, setGTotalIndustryA] = useState([])
  const [gTotalIndustryB, setGTotalIndustryB] = useState([])
  const [tableTerritory, setTableTerritory] = useState([])
  const [gTeriitoryA, setGTerritoryA] = useState([])
  const [gTeriitoryB, setGTerritoryB] = useState([])

  const handleDateChange = value => {
    setSelectedDate(value)
  }

  const reloadTotalIndustry = async () => {
    const [totalIndustry, gTotalIndustry, gTotalIndustryA, gTotalIndustryB] = await Promise.all([
      boardReportsService.getTotalMarketShare('1', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketShareGraphics('1', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketShareGraphics('2a', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketShareGraphics('2b', selectedDate.getFullYear()),
    ])
    setTotalIndustry(totalIndustry)
    setGTotalIndustry(gTotalIndustry)
    setGTotalIndustryA(gTotalIndustryA)
    setGTotalIndustryB(gTotalIndustryB)
  }

  const getTerritories = async () => {
    const response = await polygonsService.getTerritorios('2')
    Promise.all(
      response.map(
        async value =>
          await boardReportsService.getTotalMarketShareByTerritory('2', selectedDate.getFullYear(), value.territorio)
      )
    ).then(response => {
      setTableTerritory(response)
    })
  }

  const getTerritoriesgGraphicsA = async () => {
    const response = await polygonsService.getTerritorios('2')
    Promise.all(
      response.map(
        async value =>
          await boardReportsService.getTotalMarketShareByTerritoryGrapics(
            '3a',
            selectedDate.getFullYear(),
            value.territorio
          )
      )
    ).then(response => {
      setGTerritoryA(response)
    })
  }

  const getTerritoriesgGraphicsB = async () => {
    const response = await polygonsService.getTerritorios('2')
    Promise.all(
      response.map(
        async value =>
          await boardReportsService.getTotalMarketShareByTerritoryGrapics(
            '3b',
            selectedDate.getFullYear(),
            value.territorio
          )
      )
    ).then(response => {
      setGTerritoryB(response)
    })
  }
  useEffect(() => {
    getTerritories()
  }, [])

  useEffect(() => {
    reloadTotalIndustry()
    getTerritoriesgGraphicsA()
    getTerritoriesgGraphicsB()
  }, [selectedDate])

  return (
    <TotalIndustriCompanyPage
      tableTerritory={tableTerritory}
      handleDateChange={handleDateChange}
      totalIndustry={totalIndustry}
      gTotalIndustryA={gTotalIndustryA}
      gTotalIndustryB={gTotalIndustryB}
      gTeriitoryA={gTeriitoryA}
      gTeriitoryB={gTeriitoryB}
      gTotalIndustry={gTotalIndustry}
      selectedDate={selectedDate}
      getTerritories={getTerritories}
    />
  )
}

export default TotalIndustryCompanyContainer
